module.exports = __webpack_public_path__ + "static/media/spears.b17caf5c.png";